const dbName = 'sleepiz-data-db';
const storeName = 'kpidata';
const accessTimeStamp = 'kpi-access-timestamp';
const version = 2;
/**
 * @type {IDBOpenDBRequest}
 */
let request;

/**
 * @type {IDBDatabase}
 */
let db;

export const initDB = () => {
  return new Promise((resolve, reject) => {
    // open the connection
    request = indexedDB.open(dbName, version);

    request.onupgradeneeded = e => {
      console.log(
        'running upgrade',
        ' old: ',
        e.oldVersion,
        ' new: ',
        e.newVersion,
      );
      db = request.result;
      db.onversionchange = () => {
        resolve(true);
      };

      if (e.oldVersion < 1) {
        // if the data object store doesn't exist, create it
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName);
        }
      }

      if (!e.oldVersion < 2) {
        if (!db.objectStoreNames.contains(accessTimeStamp)) {
          db.createObjectStore(accessTimeStamp);
        }
      }
    };

    request.onsuccess = () => {
      const db = request.result;

      // cleanup old recordings;
      const tx = db.transaction([storeName, accessTimeStamp], 'readwrite');
      const tx_timestamp = tx.objectStore(accessTimeStamp);
      const tx_res = tx_timestamp.openCursor();

      const tx_storeName = tx.objectStore(storeName);
      tx_res.onsuccess = async e => {
        const cursor = e.target.result;
        if (cursor) {
          let key = cursor.primaryKey;
          let value = cursor.value;
          cursor.continue();

          const now = new Date().getTime();
          const diff = now - value;
          if (diff > 1000 * 60 * 60 * 24 * 7) {
            tx_storeName.delete(key);
            tx_timestamp.delete(key);
          }
        } else {
          resolve(true);
        }
      };
    };

    request.onerror = () => {
      reject(request.error);
    };
  });
};

export const storeData = async (data, key) => {
  if (!db) {
    await initDB();
  }

  return new Promise((resolve, reject) => {
    const store_request = indexedDB.open(dbName, version);

    store_request.onsuccess = () => {
      // console.log('request.onsuccess - storeData', data);
      db = store_request.result;
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      store.add(data, key);

      const tx_ = db.transaction(accessTimeStamp, 'readwrite');
      const tx_timestamp = tx_.objectStore(accessTimeStamp);
      let time = new Date().getTime();
      tx_timestamp.put(time, key);

      resolve(true);
    };

    store_request.onerror = () => {
      reject(request.error);
    };
  });
};

export const getStoreData = async nameOfStore => {
  if (!db) {
    await initDB();
  }

  return new Promise((resolve, reject) => {
    const getstore_request = indexedDB.open(dbName, version);

    getstore_request.onsuccess = () => {
      // console.log('request.onsuccess - getStoreData');
      db = getstore_request.result;
      const tx = db.transaction(nameOfStore, 'readonly');
      const store = tx.objectStore(nameOfStore);
      const res = store.getAll();
      res.onsuccess = () => {
        resolve(res.result);
      };
      getstore_request.onerror = () => {
        reject(getstore_request.error);
      };
    };
  });
};

export const getStoreKeyData = async key => {
  if (!db) {
    await initDB();
  }
  // console.log('requesting-key: ', key);
  return new Promise((resolve, reject) => {
    const getstore_key_request = indexedDB.open(dbName, version);

    getstore_key_request.onsuccess = () => {
      db = getstore_key_request.result;
      const tx = db.transaction([storeName, accessTimeStamp], 'readwrite');
      const store = tx.objectStore(storeName);
      const res = store.get(key);
      // console.log('store-details: ', { storeName, accessTimeStamp, key });
      res.onsuccess = () => {
        if (res.result) {
          const timestamp = tx.objectStore(accessTimeStamp);
          timestamp.put(new Date().getTime(), key);
        }
        resolve(res.result);
        if (res.result) {
          const tx_timestamp = tx.objectStore(accessTimeStamp);
          tx_timestamp.put(new Date().getTime(), key);
        }
      };
    };

    getstore_key_request.onerror = () => {
      reject(request.error);
    };
  });
};

export const deleteFromStore = async key => {
  if (!db) {
    await initDB();
  }

  return new Promise((resolve, reject) => {
    const delete_request = indexedDB.open(dbName, version);

    delete_request.onsuccess = () => {
      // console.log('request.onsuccess - deleteFromStore', key);
      db = delete_request.result;
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      const res = store.delete(key);

      // add listeners that will resolve the Promise
      res.onsuccess = () => {
        resolve(true);
      };
      delete_request.onerror = () => {
        reject(delete_request.error);
      };
    };
  });
};

export const deleteDatabase = async () => {
  if (!db) {
    await initDB();
  }

  return new Promise((resolve, reject) => {
    const delete_db_request = indexedDB.deleteDatabase(dbName);

    delete_db_request.onsuccess = () => {
      // console.log('request.onsuccess - deleteDatabase done', storeName);
      resolve();
    };

    delete_db_request.onerror = () => {
      reject(delete_db_request.error);
    };
  });
};
